import { faFolder } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { FC } from "react";
import type { Project } from "../../api/dto";

export const ProjectTile: FC<{ project: Project; onClick?: () => void }> = (props) => {
  return (
    <div
      className={`border border-slate-200 bg-white rounded ${props.onClick ? "hover:bg-brand-50 hover:border-brand-400 hover:shadow-md" : ""} cursor-default`}
      onClick={props.onClick}
    >
      {props.project.logo ? (
        <>
          <img
            src={`${props.project.logo}`}
            alt=""
            className={
              "h-24 w-full px-8 py-4 bg-white border-b border-inherit object-contain rounded-t"
            }
          />
        </>
      ) : (
        <>
          <div
            className={
              "h-24 w-full flex items-center justify-center bg-white border-b border-inherit"
            }
          >
            <FontAwesomeIcon icon={faFolder} className={"text-slate-300 text-2xl"} />
          </div>
        </>
      )}
      <div className={"font-bold text-base px-4 my-4"}>{props.project.name}</div>
    </div>
  );
};
